<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="shopLibrary content-box">
			<platformTab @change="handleClick" :showAll="false" :platformId="platformId"></platformTab>
			<div v-show="showPlatformContent" class="tab-btn mt-12" v-if="$auth.hasPermi('system:shopGroup:createGroup')">
				<create-dialog @refresh="getShopGroupList" ref="createDialog" :platformId="platformId"></create-dialog>
			</div>
			<div class="search" v-show="showPlatformContent">
				<search ref="search" @onSubmit="onSubmit"></search>
			</div>
		</Panel>
		<Panel v-show="showPlatformContent">
			<div class="multi-table">
				<multi-table ref="multiTable" :columns="columnsList" @gePartnerList="gePartnerList" :list="list" :total="total">
					<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
				</multi-table>
			</div>
		</Panel>
		<recommendDrawer ref="recommendDrawer" :platformId="platformId"></recommendDrawer>
		<del-dialog ref="delDialog" @delSuccess="getShopGroupList"></del-dialog>
	</div>
</template>
<script>
import { columns } from './columns';
import createDialog from './components/createDialog.vue';
import { groupList, groupStatus, shopGroupList } from '@/api/shopManage';
import delDialog from '@/views/common/dialog/delete.vue';
import recommendDrawer from '@/views/shopManage/components/recommendDrawer';
import search from './components/search.vue';
import { platformMixin } from '@rd/rd-ui';
import { menuType } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
export default {
	name: 'shopLibrary',
	components: {
		createDialog,
		recommendDrawer,
		search,
		delDialog,
		empty,
	},
	mixins: [platformMixin],
	data() {
		return {
			columns,
			list: [],
			pageInfo: {
				page_index: 1,
				page_size: 10,
				item_total: 0,
			},
			total: '',
			params: {
				page_index: 1,
				page_size: 10,
			},
			isSearch: false,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		//过滤要筛选的字段
		screenList() {
			return this.columns.filter(item => item.isSearch);
		},
		columnsList() {
			return this.columns.filter(item => !item.isNoShow);
		},
	},
	created() {
		this.getShopGroupList();
	},
	methods: {
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.params = {
				page_index: 1,
				page_size: 10,
			};
			this.$refs['search'].onClear();
			// this.getShopGroupList();
		},
		//获取商品组列表
		async getShopGroupList(isSearch) {
			this.isSearch = Boolean(isSearch);
			this.params.platform_id = this.platformId;
			const { code, data: { list = [], page = {} } = {} } = await groupList(this.params);
			if (code === 0) {
				this.list = list.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = `${page.item_total}`;
			}
		},
		//操作按钮
		getButtons({ group_status, is_self, is_delete }) {
			const tuiguang = {
				label: +group_status === 1 ? '关闭推广' : '开启推广',
				type: 'text',
				notSelf: !is_self,
				classtype: +group_status === 1 ? '1' : '0',
				isShow: this.$auth.hasPermi('system:goods:extend'),
				click: row => row.is_self && this.extension(row),
			};
			const viewGoodsList = {
				label: '查看',
				type: 'text',
				classtype: 2,
				isShow: this.$auth.hasPermi('system:shopGroup-query'),
				click: ({ id, platform_id }) =>
					this.$router.push({
						path: '/shopManage/shopGroup/detail/list',
						query: { groupId: id, platformId: platform_id },
					}),
			};
			const shareToDr = {
				label: '分享',
				type: 'text',
				isShow: this.$auth.hasPermi('system:goods:promote'),
				click: async row => {
					const {
						code,
						data: { list },
					} = await shopGroupList({ group_id: row.id, page_index: 1, page_size: 100 });
					if (code !== 0) return;
					this.$refs.recommendDrawer.show(list, 1, row.id);
				},
			};
			const delGroup = {
				label: '删除',
				type: 'text',
				isShow: this.$auth.hasPermi('system:shopGroup:deleteGoodGroup'),
				notSelf: !is_delete,
				click: row => {
					if (is_delete) {
						this.$refs.delDialog.delInit(row, menuType.gruop, '是否确认删除商品组？');
					}
				},
			};
			const arr = [delGroup, tuiguang, shareToDr, viewGoodsList];
			return arr.filter(item => item.isShow);
		},
		//开启推广
		async extension({ id: group_id, group_status }) {
			let params = { group_id };
			if (+group_status === 1) {
				this.$confirm('确认关闭推广吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(async () => {
					const { code } = await groupStatus(params);
					if (code === 0) this.$message.success('关闭成功');
					this.getShopGroupList();
				});
			} else {
				const { code } = await groupStatus(params);
				if (code === 0) this.$message.success('开启成功');
				this.getShopGroupList();
			}
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs.multiTable.resetPage();
			this.getShopGroupList(1);
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getShopGroupList();
		},
	},
};
</script>
